import { useCallback } from "react";
import loginOrCreate from "../requests/loginOrCreate";
// Do not want this cached
export default function useLoginOrCreate() {
    return useCallback(async (request) => {
        return await loginOrCreate(request);
    }, []);
}
//# sourceMappingURL=useLoginOrCreate.js.map